/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Nemovitosti_CzInputs */

const cs_enum_nemovitosti_cz = /** @type {(inputs: Enum_Nemovitosti_CzInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nemovitosti.cz`)
};

const en_enum_nemovitosti_cz = /** @type {(inputs: Enum_Nemovitosti_CzInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nemovitosti.cz`)
};

/**
* | output |
* | --- |
* | "Nemovitosti.cz" |
*
* @param {Enum_Nemovitosti_CzInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_nemovitosti_cz = /** @type {((inputs?: Enum_Nemovitosti_CzInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Nemovitosti_CzInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_nemovitosti_cz(inputs)
	return cs_enum_nemovitosti_cz(inputs)
});